import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { compose, nest } from 'recompose';
import FormButtons from 'components/FormButtons';
import { connect } from 'react-redux';
import { withSession } from '../../../../sessions';
import Form from '../Form';
import SimulationHeader from '../Header';
import SummaryInner from './SummaryInner';
import withSummary from './withSummary';
import withRouter from '../../../../withRouter';
import { setModal } from '../../../../../actions';
import Icon from '../../../../../common/components/Icon';
import xmark from '../../../../../images/pictos/triangle-exclamation.svg';

const WarningModal = ({ close }) => (
    <div className="modal-container" style={{ margin: '20px' }}>
        <Icon icon="times" className="close-action" onClick={close} style={{ width: '20px' }} />
        <div className="echec-info-container">
            <img className="xmark" src={xmark} alt="xmark" />
            <p>
                Certaines données renseignées ne permettent pas de calculer correctement cette opération. <br />
                Veuillez vous rapprocher de votre chargé(e) d&apos;affaires afin de vérifier la bonne saisie.
            </p>
        </div>
        <button
            onClick={close}
            className="lastButtonRipForm sendButton"
            type="button"
        >
            Reprendre la saisie de la simulation
        </button>
    </div>
);

WarningModal.propTypes = {
    close: PropTypes.func.isRequired,
};

const SummaryForm = ({
    navigate,
    params: { id, simulationId },
    simulation,
    children,
    session,
    rip,
    errorSimulationSummary,
    close,
    showEchecModal,
}) => {
    const isApproved = session.permissions.mayDownloadSimulationPDF(simulation, rip);
    const handleSubmit = (event) => {
        // prevent the browser to reload the document
        event.preventDefault();
        // redirect to the next step
        navigate(isApproved
            ? `/rip/${id}/simulations/`
            : `/rip/${id}/simulations/${simulationId}/approval/request`);
    };

    useEffect(() => {
        if (true === errorSimulationSummary) {
            showEchecModal(close);
        }
    }, [errorSimulationSummary]);

    return (
        <Form handleSubmit={handleSubmit} needFunding={simulation.needFunding}>
            <div className="simulation-form-inner">
                <div className="container">
                    <SimulationHeader />
                    {
                        !errorSimulationSummary && (
                            children
                        )
                    }
                </div>
            </div>
            <FormButtons
                back={`/rip/${id}/simulations/${simulationId}/simulation`}
                list={`/rip/${id}/simulations/`}
                nextButtonContent={isApproved ? 'Terminer' : 'Continuer'}
            />
        </Form>
    );
};

SummaryForm.propTypes = {
    params: PropTypes.shape({
        id: PropTypes.string,
        simulationId: PropTypes.string,
    }),
    navigate: PropTypes.shape({}),
    simulation: PropTypes.shape({
        needFunding: PropTypes.bool,
    }).isRequired,
    children: PropTypes.node.isRequired,
    session: PropTypes.shape({
        permissions: PropTypes.shape({
            mayDownloadSimulationPDF: PropTypes.func,
        }),
    }).isRequired,
    rip: PropTypes.shape({}).isRequired,
    errorSimulationSummary: PropTypes.bool,
    close: PropTypes.func,
    showEchecModal: PropTypes.func,
};

export default compose(
    withSummary,
    withRouter,
    connect(null, (dispatch, {
        navigate,
        params: { id, simulationId },
    }) => ({
        showEchecModal: (close) => dispatch(setModal(() => <WarningModal close={close} />, false)),
        close: () => {
            dispatch(setModal(null));
            navigate(`/rip/${id}/simulations/${simulationId}/simulation`);
        },
    })),
    withSession,
)(nest(SummaryForm, SummaryInner));
